/**
 * Loading skeleton tiles for the storefront grid.
 *
 * Mirrors the .tile structure so the swap-in from skeleton to real content is
 * layout-stable: 16:9 media block on top, label/version row + author + chips
 * underneath.
 */

export function renderSkeletonTiles(host: HTMLElement, count = 8): void {
  host.innerHTML = '';
  for (let i = 0; i < count; i++) host.appendChild(buildOne());
}

function buildOne(): HTMLElement {
  const tile = document.createElement('article');
  tile.className = 'tile skeleton';
  tile.setAttribute('aria-hidden', 'true');
  tile.innerHTML = `
    <div class="tile-media skel-media"></div>
    <div class="tile-body">
      <div class="tile-title-row">
        <span class="skel-line skel-line-title"></span>
        <span class="skel-line skel-line-badges"></span>
      </div>
      <span class="skel-line skel-line-desc"></span>
      <span class="skel-line skel-line-desc short"></span>
    </div>
  `;
  return tile;
}
